'use client';

import * as React from 'react';
export const TooltipProviderContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") TooltipProviderContext.displayName = "TooltipProviderContext";
export function useTooltipProviderContext() {
  return React.useContext(TooltipProviderContext);
}